import React, { useState } from "react";
import { Link } from "react-router-dom";
import { authApi } from "../auth/authApi";
import logo from "../assets/img/boersenkusecpixabay.png";
import "./login.css";
import TurnstileWidget from "../components/TurnstileWidget";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [done, setDone] = useState(false);
    const [turnstileToken, setTurnstileToken] = useState("");
    const [message, setMessage] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setError("");

        if (!turnstileToken) {
            setMessage("Bitte bestätige zuerst, dass du ein Mensch bist.");
            return;
        }

        if (!email) {
            setError("Bitte E-Mail-Adresse eingeben.");
            return;
        }

        try {
            setLoading(true);
            await authApi.forgotPassword(email);
            setDone(true);
        } catch (err) {
            setError(err.message || "Passwort-Reset konnte nicht angefordert werden.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-root">
            <div className="login-left">
                <img src={logo} alt="Logo" className="login-logo" />
                <span className="company-name">
                    Künstliche-Intelligenz-Marktanalyse-Terminal
                </span>
            </div>

            <div className="login-divider" />

            <div className="login-right">
                <h1>Passwort vergessen</h1>
                <p>
                    Bitte geben Sie Ihre E-Mail-Adresse ein. Falls ein Konto existiert,
                    senden wir Ihnen einen Link zum Zurücksetzen des Passworts.
                </p>

                {done ? (
                    <div className="login-success">
                        Falls die E-Mail-Adresse gültig ist, wurde ein Link zum Zurücksetzen
                        des Passworts versendet.
                    </div>
                ) : (
                    <form onSubmit={submit}>
                            <input style={{ width: "300px" }}
                            name="email"
                            type="email"
                            placeholder="E-MAIL"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                            <TurnstileWidget style={{ width: "300px" }} onVerify={setTurnstileToken} />

                        {error && <div className="login-error">{error}</div>}

                            <button style={{ width: "300px" }} disabled={loading}>
                            {loading ? "Wird gesendet ..." : "Reset-Link anfordern"}
                        </button>

                        <div className="login-links">
                            <Link to="/login" className="login-link">
                                Zurück zur Anmeldung
                            </Link>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}